import { render } from "./OddIcon.vue?vue&type=template&id=510851e4&scoped=true"
import script from "./OddIcon.vue?vue&type=script&lang=js"
export * from "./OddIcon.vue?vue&type=script&lang=js"

import "./OddIcon.vue?vue&type=style&index=0&id=510851e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510851e4"]])

export default __exports__